import clsx from 'clsx';

interface MiniProgressBarProps {
    value?: number | null;
    width?: number;
    height?: number;
    showLabel?: boolean;
    className?: string;
}

const clampPercent = (value?: number | null) => {
    if (!Number.isFinite(Number(value))) {
        return 0;
    }
    const pct = Math.round(Number(value));
    return Math.max(0, Math.min(100, pct));
};

export default function MiniProgressBar({
    value = 0,
    width = 50,
    height = 10,
    showLabel = true,
    className,
}: MiniProgressBarProps) {
    const pct = clampPercent(value);
    return (
        <div className={clsx('flex items-center gap-1 text-gray-600', className)}>
            <div
                className='flex-shrink-0 rounded-full bg-gray-200 overflow-hidden relative'
                style={{ width, height }}
            >
                <div
                    className='absolute inset-y-0 left-0 bg-gradient-to-r from-indigo-500 to-blue-500 transition-all duration-300'
                    style={{ width: `${pct}%` }}
                />
            </div>
            {showLabel && (
                <span className='text-[11px] font-semibold leading-none whitespace-nowrap'>{pct}%</span>
            )}
        </div>
    );
}

